import React from "react";
import { useTranslation } from "react-i18next";
import { FlightDetails } from "../../../../types";

interface Props {
  result: FlightDetails;
}

function SearchFlightsResultDetailSFO({ result }: Props) {
  const { t } = useTranslation();
  return (
    <div className="column flight-detail is-multiline">
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_AIRCRAFT")}</p>
        <p>{result.aircraftName}</p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_DEPARTURE")}</p>
        <p>{result.departName}</p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_ARRIVAL")}</p>
        <p>{result.arrivalName}</p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_CLASSES_OFFERED")}</p>
        <p>
          {result.classFirst && t("CLASS_F")}{" "}
          {result.classBusiness && t("CLASS_B")}{" "}
          {result.classEconomy && t("CLASS_E")}
        </p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">
          {t("RADIO_SORTBY_DEPARTURE_TIME")}
        </p>
        <p>
          {`${result.departureDateAsString} ${result.departureTimeAsString} (local time)`}
        </p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("RADIO_SORTBY_ARRIVAL_TIME")}</p>
        <p>
          {`${result.arrivalDateAsString} ${result.arrivalTimeAsString} (local time)`}
        </p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_TRAVEL_TIME")}</p>
        <p>
          {Math.floor(result.travelTime / 60)}hrs {result.travelTime % 60}mins
        </p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_TERMINAL")}</p>
        <p>{result.departureTerminal}</p>
      </div>
      <div className="column is-one-third">
        <p className="has-text-weight-bold">{t("LABEL_TERMINAL")}</p>
        <p>{result.arrivalTerminal}</p>
      </div>
    </div>
  );
}

export default SearchFlightsResultDetailSFO;
